import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { IconComponent } from '@shared/components/icons/icon/icon.component'
import { EIcons } from '@shared/models'

@Component({
	selector: 'app-list-page-header',
	standalone: true,
	imports: [IconComponent],
	templateUrl: './list-page-header.component.html',
	styleUrl: './list-page-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPageHeaderComponent {
	readonly title = input.required<string>()
	readonly icon = input<EIcons | null>(null)
	readonly resultsLabel = input<string | null>(null)
}
